import { create } from 'zustand';

const useContactPersonStore = create((set) => ({
  contactperson: {},

  setContactperson: (newContactperson) => set({ contactperson: newContactperson }),

  clearContactperson: () => set({ contactperson: {} }),
}));

export default useContactPersonStore;
